import { useState } from "react";

import { Select } from "@/components/inputs";

/** Create a product — Fabric's `products/create`.
 *
 *  The SLUG is derived from the name and is what goes on the wire and into the
 *  audit log; the CODE (PRD-001) is assigned automatically and is display only.
 *  Both are shown as they are decided so nobody has to discover later which one
 *  a client actually sends — that confusion cost both sessions time this week.
 */
export function ProductForm({ onCancel, onDone }: {
  onCancel: () => void;
  onDone: (name: string) => void;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("active");
  const [err, setErr] = useState("");

  const slug = name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setErr("A name is required.");
    if (!slug) return setErr("That name produces an empty slug — use letters or digits.");
    setErr("");
    onDone(name.trim());
  }

  return (
    <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span className="cap">Product name</span>
          <input className="search" value={name} autoFocus style={{ marginLeft: 0, width: 240 }}
            placeholder="Connected Cluster" onChange={(e) => setName(e.target.value)} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 4, flexGrow: 1 }}>
          <span className="cap">Description (optional)</span>
          <input className="search" value={description} style={{ marginLeft: 0, width: "100%", minWidth: 220 }}
            placeholder="TFT cluster with telematics" onChange={(e) => setDescription(e.target.value)} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span className="cap">Status</span>
          <Select value={status} onChange={(e) => setStatus(e.target.value)} style={{ minWidth: 130 }}>
            <option value="active">active</option>
            <option value="beta">beta</option>
            <option value="hidden">hidden</option>
          </Select>
        </label>
      </div>

      <div className="cap">
        Slug <span className="mono" style={{ color: "var(--t-bright)" }}>{slug || "—"}</span> — derived from the
        name, used in URLs, on the wire and in the audit log. A code like <span className="mono">PRD-004</span> is
        assigned automatically and is <strong>display only</strong>; clients never send it.
      </div>

      {err && <div style={{ fontSize: 12.5, color: "var(--bad)" }}>{err}</div>}

      <div style={{ display: "flex", gap: 8 }}>
        <button type="submit" className="btn teal sm">Create product</button>
        <button type="button" className="btn ghost sm" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
